import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useSearchParams } from 'react-router-dom-v5-compat';

import ErrorBoundaryFallback from 'components/atoms/ErrorBoundaryFallback';
import PageHeaderPusher from 'components/atoms/PageHeaderPusher';
import OperationCard from 'components/cards/OperationCard';
import BackOfficeIPCameraAddDrawer from 'components/drawers/BackOfficeIPCameraAddDrawer';
import FarmbotSecurityCameraIcon from 'components/icons/FarmbotSecurityCameraIcon';
import { SEARCH_PARAMS } from 'constants/search-params';
import { useMyUserHasInternalPermission } from 'store/modules/myUser/hooks';
import { ProtectedResource, ResourceAction } from 'types/action.enum';

import './styles.less';

export default function BackOfficeOperations() {
  const [, setSearchParams] = useSearchParams();

  const canProvisionIPCameras = useMyUserHasInternalPermission({
    resource: ProtectedResource.IP_CAMERA,
    action: ResourceAction.ADD
  });

  const openIPCameraAddDrawer = () => {
    setSearchParams((prev) => {
      const newSearchParams = new URLSearchParams(prev);
      newSearchParams.set(SEARCH_PARAMS.DRAWER.key, SEARCH_PARAMS.DRAWER.values.ADD_IP_CAMERA);
      return newSearchParams;
    });
  };

  const operations = [
    ...canProvisionIPCameras ? [
      {
        title: 'Add IP Camera',
        onClick: openIPCameraAddDrawer,
        caption: 'For Farmbot Security Cameras manufactured by Land Watch',
        Icon: FarmbotSecurityCameraIcon
      }
    ] : []
  ];

  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
      <PageHeaderPusher>
        <>
          <BackOfficeIPCameraAddDrawer />
          {!operations.length ? (
            <div className="BackOfficeOperations-empty-state">
              No allowed operations
            </div>
          ) : (
            <div className="BackOfficeOperations-operations-list">
              {operations.map((operation, index) => (
                <OperationCard
                  key={index}
                  title={operation.title}
                  caption={operation.caption}
                  Icon={operation.Icon}
                  onClick={operation.onClick}
                />
              ))}
            </div>
          )}
        </>
      </PageHeaderPusher>
    </ErrorBoundary>
  );
}